import { Controller } from "@hotwired/stimulus"

// Задача 6.1: Яндекс.Метрика — SPA-хиты на Turbo-навигации + цель "signup" на первом рендере
// после регистрации. Ничего не делает (и не падает), если window.ym не подгружен —
// счётчик отсутствует в dev/test (ENV["YANDEX_METRICA_ID"] пуст, партиал ничего не рендерит).
export default class extends Controller {
  static values = { id: Number, goal: String }

  connect() {
    this.hit = () => {
      if (window.ym) window.ym(this.idValue, "hit", window.location.pathname)
    }
    document.addEventListener("turbo:load", this.hit)

    // Цель "signup" фиксируется один раз на первом рендере после регистрации (flash[:signup]
    // → data-metrica-goal-value="signup"). Флэш очищается Rails-ом после одного рендера, так
    // что повторный turbo:load/обновление страницы цель уже не отправит.
    if (this.hasGoalValue && this.goalValue) this.goal()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.hit)
  }

  // Может вызываться и как Stimulus-action (data-action="...->metrica#goal"), и напрямую из
  // connect() — в обоих случаях аргумент (Event или undefined) игнорируется, отправляется
  // фиксированная цель из goalValue (по умолчанию "signup").
  goal() {
    if (window.ym) window.ym(this.idValue, "reachGoal", this.goalValue || "signup")
  }
}
